export default __webpack_public_path__ + "static/media/alicia.9011f1ec.jpg";